import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'small' | 'medium' | 'large';
}

export default function MovieCard({ movie, size = 'medium' }: MovieCardProps) {
  const sizeClasses = {
    small: 'w-[160px]',
    medium: 'w-[200px]',
    large: 'w-[240px]',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className={`${sizeClasses[size]} group block flex-shrink-0`}
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-800 mb-3">
        <img
          src={movie.poster}
          alt={`${movie.title} - ${movie.subcategory}电影海报`}
          title={`${movie.title} - 成全影院高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3">
          <p className="text-xs text-foreground-200 line-clamp-2 leading-relaxed">{movie.description}</p>
        </div>
        {movie.isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-950 text-xs font-bold px-2 py-0.5 rounded-md">
            NEW
          </span>
        )}
        {movie.isHot && !movie.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md">
            热播
          </span>
        )}
        <div className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm text-accent-400 text-xs font-bold px-1.5 py-0.5 rounded-md flex items-center gap-0.5">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating}
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1 mb-1">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span className="bg-background-800 px-1.5 py-0.5 rounded">{movie.subcategory}</span>
        <span>{movie.year}</span>
      </div>
    </Link>
  );
}